import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wm-role-editor',
    templateUrl: './role-editor.component.html',
    styleUrls: ['./role-editor.component.css'],
    standalone: false
})
export class RoleEditorComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
